module.exports = __webpack_public_path__ + "img/message_bg_02.c5d78eca.png";